<input
  #inputEl
  type="number"
  inputmode="decimal"
  [step]="step()"
  [min]="min()"
  [max]="max()"
  [id]="inputId"
  [formControl]="control()"
  [readOnly]="readOnly()"
  [class.is-edited]="control().dirty"
  [class.has-error]="control().invalid"
  [attr.aria-label]="label()"
  [attr.aria-invalid]="control().invalid"
  [attr.aria-describedby]="errorMessage() ? errorId : null"
  (keydown)="onKeydown($event)"
/>
@if (errorMessage()) {
  <span class="table-input-error body3" [id]="errorId">{{
    errorMessage()
  }}</span>
}
